const $inject = ['$scope',  'dataService','moment'];

const lbaCompanyReferenceConfigAuditItemCtrl = function ($scope, dataService,moment) {
    const vm = this;
    vm.$onInit = () => {
      vm.formatDateLocal = formatDateLocal;
      vm.item = dataService.data.activeItemSubItem;
      $scope.$watch(() => dataService.data.activeItemSubItem, () => {
        vm.item = dataService.data.activeItemSubItem;
      });
    };
   

    function formatDateLocal(val){
      return moment.utc(val).local().format("M/D/Y hh:mm:ss A Z");
    }
};

lbaCompanyReferenceConfigAuditItemCtrl.$inject = $inject;

export default lbaCompanyReferenceConfigAuditItemCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaCompanyReferenceConfigAuditItem/lbaCompanyReferenceConfigAuditItemCtrl.js